import axios from 'axios';
import React, {useState, useEffect, useMemo, Fragment, useRef} from 'react';

import { FormControl, InputLabel, Input, FormHelperText, Alert } from '@mui/material';
import WebService from '@util/webService'
import {encodeParams, getAction, getCodeName, printVariable} from '@util/helper'
// redux
import { useSelector, useDispatch } from 'react-redux';
// MUI Table
import CssBaseline from '@mui/material/CssBaseline'
import MUITable from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import TableFooter from '@mui/material/TableFooter'
import TableSortLabel from '@mui/material/TableSortLabel';
// react-table
import { useTable, useExpanded } from 'react-table'
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { Checkbox, FormGroup, FormControlLabel, Typography, Snackbar, TablePagination, TextField,withStyles,InputBase, MenuItem, Select } 
  from '@mui/material';
import {tablePaginationClasses} from '@mui/material/TablePagination'
import { styled, alpha } from '@mui/material/styles';
import '@scss/App.scss'
import Button from '@mui/material/Button'
import FlatButton from '@components/FlatButton';
import useSnackbar from '@hooks/useSnackbar';
import MyTableHead from '@components/MyTableHead';
import useIndicator from '@hooks/useIndicator';
import Indicator from '@components/Indicator';
import MyDialog from '@components/MyDialog';
import useForm from '@hooks/useForm';
import Box from '@mui/material/Box';
import ConfirmDialog from "@components/ConfirmDialog";
// pagination
import { useTheme } from '@mui/material/styles';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import { useLocation } from 'react-router-dom';
import MyDialog2 from '@components/MyDialog2';
import ProfileCompanyTeacherPart from './profile-company.teacher.part';
import ProfileCompanyTeacherPartTime from './profile-company.teacher.part.time';


import {
  Avatar,
  Grid,
  Container,
  Paper,
} from '@mui/material/';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import moment from 'moment';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import { searchSchool } from '@util/helper';

import RegisterCompanyPage from '@pages/register/register-company.page';
import ProfileCompanySchoolPart from './profile-company.school.part';
import {useParams} from "react-router-dom";
import useAlert from "@hooks/useAlert";
import { has, over } from 'lodash';
import { DataArray } from '@mui/icons-material';
const Boxs = styled(Box)`
      padding-bottom: 40px !important;
    `;


const dateFormat = "YYYY-MM-DD HH:mm:ss"
const timeFormat = "HH:mm"
const FormHelperTexts = styled(FormHelperText)`
  width: 100%;
  padding-left: 16px;
  font-weight: 700 !important;
  color: #d32f2f !important;
`;

const hasTimeOverlap = (arr1, arr2) => {
  console.log('arr1=>', arr1)
  console.log('arr2=>', arr2)
  for (const a of arr1) {
    for (const b of arr2) {
      if (a.weekCode === b.weekCode) { // Only check overlap on the same day
        const startA = moment(a.startTime, timeFormat)
        const endA = moment(a.endTime, timeFormat)
        const startB = moment(b.startTime, timeFormat)
        const endB = moment(b.endTime, timeFormat)

        if (startA.isBefore(endB) && startB.isBefore(endA)) {
          return true
        }
      }
    }
  }
  return false
}

const ProfileCompanyTeacherPage = () => {
  const defUrl = '/company'
  const {more} = useParams()
  const fields = [
    {field: 'id', placeholder: 'ID',    type:'text', value:-1, visible: more && (more === 'more'), canSrch: false, selList:[], sortable: true},
    {field: 'userName', placeholder: '강사명',    type:'text', value:'', visible: true, canSrch: false,selList:[], sortable: true},
    {field: 'phone', placeholder: '전화번호',    type:'text', value:'', visible: true, canSrch: false,selList:[], sortable: true},
    {field: 'schoolName', placeholder: '학교명',    type:'text', value:'', visible: true, canSrch: false,selList:[], sortable: true},
    {field: 'smstName', placeholder: '학기',    type:'text', value:'', visible: true, canSrch: false,selList:[], sortable: true},
    {field: 'statName', placeholder: '상태',    type:'text', value:'', visible: true, canSrch: false,selList:[], sortable: true},
    {field: 'companyName', placeholder: '위탁업체명',    type:'text', value:'', visible: true, canSrch: false,selList:[], sortable: true},
    {field: 'rltnCode', placeholder: '관계코드',    type:'text', value:'', visible: false, canSrch: false,selList:[], sortable: true},
    {field: 'rltnName', placeholder: '관계',    type:'text', value:'', visible: false, canSrch: false,selList:[], sortable: true},
    {field: 'title', placeholder: '과목명',    type:'text', value:'', visible: true, canSrch: false,selList:[], sortable: false},
    {field: 'statCode', placeholder: '상태코드',    type:'text', value:'', visible: false, canSrch: false,selList:[], sortable: true},
  ]
  const [sortBy, set_sortBy] = useState('statName')
  const [sortDirection, set_sortDirection] = useState('asc')
  const location = useLocation()  
  const curLocationRef = useRef(location)
  const visibleColumns = fields.filter(col => col.visible)
  const defRecord = {}
  fields.forEach(d => {
    defRecord[d.field] = d.value
  })
  const dgRef = useRef()
  const dgTimeRef = useRef()
  defRecord.schoolList = []  
  const defTerms = {}
  fields.filter(col => col.canSrch).map(d => d.field).forEach(d => defTerms[d] = '')
  const [record, set_record] = useState(defRecord)
  const [companyList, set_companyList] = useState([])
  const [dataList, set_dataList] = useState([])
  const [skipPageReset, setSkipPageReset] = React.useState(false)
  const [openSnackbar, renderSnackbar] = useSnackbar()
  const [openIndicator, closeIndicator, renderIndicator] = useIndicator()
  const dgHandler = useState(false)
  const [selIdx, set_selIdx] = useState(-1)
  const [totalCount, set_totalCount] = useState(0)
  const [pageInfo, set_pageInfo] = useState({pageNum:0, pageSize: 10})
  const [terms, _set_terms] = useState(defTerms)
  const termsRef = useRef(terms)
  const [termsKey, set_termsKey] = useState(Date.now())
  const recordRef = useRef()
  const lectureRef = useRef()
  const schoolRef= useRef()
  const [demand, set_demand] = useState({
    schs:[]
  })
  // redux
  const codeGroups = useSelector(state => state.codeGroupReducer)
  const codes = useSelector(state => state.codeReducer)
  const statCodes = codes.filter(r => r.codeGroupId === 'SA17')
  statCodes.unshift({code:'', name:'선택안함'})
  const weekCodes = codes.filter(r => r.codeGroupId === 'SB07')
  const account = useSelector(state => state.accountReducer)
	const schola = useSelector((state) => state.scholaReducer)
  const buttonRef = useRef(null)
  const originRef = useRef([])
  const {alert, renderAlert} = useAlert()
  const set_terms = data => {
    termsRef.current = data
    _set_terms(data)
  }

  const handleSort = (property) => {
    const direction = sortBy === property && sortDirection === 'asc' ? 'desc' : 'asc';
    set_sortBy(property)
    set_sortDirection(direction)
    set_pageInfo({...pageInfo, pageNum:0})
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      buttonRef.current.click();
    }
  };

  useEffect(() => {
      document.addEventListener('keydown', handleKeyPress);
      return () => {
        document.removeEventListener('keydown', handleKeyPress);
      };
  }, []);

  useEffect(() => {
    if(curLocationRef.current.key !== location.key) {
      curLocationRef.current = location
      set_terms({})
      set_termsKey(Date.now())
      set_pageInfo({...pageInfo, pageNum: 0})
    }
  },[location])

  useEffect(() => {
    onLoad()
  }, [])

  useEffect(() => {
    if(originRef.current)  {
      originRef.current.sort((a, b) => {
         if(a[sortBy] && b[sortBy]) {
          if(sortDirection === 'asc') {
            return a[sortBy].localeCompare(b[sortBy]);
          }
          else {
            return b[sortBy].localeCompare(a[sortBy]);
          }
        }
        else {
          return 0
        }
      })

      const startIdx = pageInfo.pageNum * pageInfo.pageSize 
      let size = pageInfo.pageSize
      if(size == -1) {
        size = originRef.current.length
      }
      const records = originRef.current.slice(startIdx, startIdx + size)
      set_dataList(records)
    }
  }, [pageInfo])
  /*
  useEffect(() => {
    if(sortBy && sortDirection && dataList.length > 0) {
      openIndicator()
      const newDataList = [...dataList]
      newDataList.sort((a, b) => {
        if(sortDirection === 'asc') {
          return a[sortBy].localeCompare(b[sortBy]);
        }
        else {
          return b[sortBy].localeCompare(a[sortBy]);

        }
      }) 
      set_dataList(newDataList)
      closeIndicator()
    }
  }, [sortBy, sortDirection, dataList])
  */ 
  const sortedData = dataList.sort((a, b) => {
    if(a[sortBy] && b[sortBy]) {
      if(sortDirection === 'asc') {
        return a[sortBy].localeCompare(b[sortBy]);
      }
      else {
        return b[sortBy].localeCompare(a[sortBy]);
      }
    }
    else {
      return 0
    }
  })

  const onLoad = async() => {
    const url = `/rltn/company/teacher/${account.user.id}`
    const newTerms = {};
    Object.keys(termsRef.current).forEach(key => {
      if (termsRef.current[key] !== '') {
        newTerms[key] = termsRef.current[key];
      }
    });

    const params = {
      schoolId: schola.id,
      terms: JSON.stringify(newTerms) 
    }
    openIndicator()
    const resp = await WebService.get(url, params)
    closeIndicator()

    if(resp.repCode === 'ack') {
      const repMessage = JSON.parse(resp.repMessage)
      // const records = JSON.parse(repMessage.records)
      const serverRecords = JSON.parse(repMessage.records)
      // debug
      /*
      const records2 = []
      for(let i = 0; i < 10;i++) {
        const r = records[i]
        if(r) {
          r.userName = r.user.name
          r.phone = r.user.phone
          r.companyName = r.company.name
          r.schoolName = r.school.name
          r.rltnName = getCodeName(codes, 'SA04', r.rltnCode)
          r.statName = getCodeName(codes, 'SA17', r.statCode)
          records2.push(r)
        }
      }
      set_dataList(records2)
      */ 
      const records = []
      const excludeUserIds = []
      serverRecords.forEach(r => {
        r.userName = r.user.name? r.user.name : '회원탈퇴'
        r.phone = r.user.phone
        r.companyName = r.company.name
        r.schoolName = r.school.name
        r.smstName = r.smst? r.smst.year + '/' +  r.smst.gisu : ''
        r.rltnName = getCodeName(codes, 'SA04', r.rltnCode)
        r.statName = getCodeName(codes, 'SA17', r.statCode)
        records.push(r)

        if(demand.schs.length > 0) {
          if(r.smst) {
            if(
              moment(r.smst.lectureStime, dateFormat).isBefore(moment(demand.smst.lectureEtime, dateFormat)) &&
              moment(demand.smst.lectureStime, dateFormat).isBefore(moment(r.smst.lectureEtime, dateFormat)) 
            ) {
              console.log(`${r.userName} ${r.title} smst overlap`)
              if(r.lschs && r.lschs.length > 0) {
                const overlap = hasTimeOverlap(demand.schs, r.lschs )
                if(overlap) {
                  excludeUserIds.push(r.user.id)
                }
              }
            }
          }
        }
      })

      originRef.current = records.filter(r => !excludeUserIds.includes(r.user.id))
      set_totalCount(originRef.current.length)
      set_pageInfo({...pageInfo, pageNum:0})
    }

    else {
      openSnackbar(resp.repMessage)
    }
  }


  const onResolve = async(rltnId, statCode) => {
    const url = `/rltn/school/teacher/resolve/${rltnId}`
    const params = {statCode: statCode}
    openIndicator()
    const resp = await WebService.post(url, {}, params)
    closeIndicator()
    if(resp.repCode === 'ack') {
      alert('처리되었습니다.')
      onLoad()
    }
    else {
      alert(resp.repMessage)
    }
  }

  const onClear = () => {
    const obj = {}
    Object.keys(terms).forEach(k => {
      ob[k] = ''
    })
    set_terms(ob)
  }

  const handleChangePage = (event, newPage) => {
    set_pageInfo({...pageInfo, pageNum: newPage })
  }
  
  const handleChangeRowsPerPage = (event) => {
    let pageSize = parseInt(event.target.value, 10)
    set_pageInfo({pageNum:0, pageSize: pageSize})
  }

  const TablePaginationActions = (props) => {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
      onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
      onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
      onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
      onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
      <Box sx={{ flexShrink: 0, ml: 2.5 }}>

        <IconButton
          onClick={handleFirstPageButtonClick}
          disabled={page === 0}
          aria-label="first page"
        >
          {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
        </IconButton>
        <IconButton
          onClick={handleBackButtonClick}
          disabled={page === 0}
          aria-label="previous page"
        >
          {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
        </IconButton>
        <IconButton
          onClick={handleNextButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="next page"
        >
          {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
        </IconButton>
        <IconButton
          onClick={handleLastPageButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="last page"
        >
          {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
        </IconButton>
      </Box>
    );
  }

  const delSchoolUserRltn = async (id) => {
    const url = `/rltn/school/user/${id}`
    const resp = await WebService.delete(url)
    console.log('resp =>', resp)
    if(resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }
    alert('삭제되었습니다.', () => onLoad())
  }


  const dg_title = '소속 강사'
  const memo_DgContent = useMemo(()=> {return <ProfileCompanySchoolPart companyList={companyList} />}, [companyList])
  if(dataList != null) {
    return (
      <div >
        <MyDialog2
          ref={dgRef}
          windowWidth='sm' 
					title={'강좌 정보'}
					component=<ProfileCompanyTeacherPart dgRef={dgRef} lectureRef={lectureRef} schoolRef={schoolRef}/>
				/>
        <MyDialog2
          ref={dgTimeRef}
          windowWidth='md' 
					title={'출강가능 요건'}
					component=<ProfileCompanyTeacherPartTime dgRef={dgTimeRef} oldDemand={demand} callback={(data) => {set_demand(data)}}/>
				/>
        <MyDialog title={dg_title} component={memo_DgContent} dialogHandler={dgHandler}/>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}>
          <div style={{ paddingRight: 10 }}>
            <h1>소속 강사 목록</h1>
          </div>
        </div>
        <div style={{paddingTop:20, }}>
          <Grid container spacing={2} key={termsKey}>
            <Grid item xs={12} md={3}>
              <TextField fullWidth label='강사명' size='small'
                defaultValue={terms?.teacherName}
                onChange={(e) => {
                  terms.teacherName = e.target.value
                  termsRef.current = terms
                }}
              />
            </Grid> 
            <Grid item xs={12} md={3} >
               <FormControl fullWidth>
                <InputLabel id='statCode'>
                  상태
                </InputLabel>
                <Select
                  labelId='catCode'
                  required
                  label='상태'
                  name={"statCode"}
                  defaultValue={terms?.statCode}
                  onChange={async (e) => {
                    terms.statCode = e.target.value
                    termsRef.current = terms
                  }}>
                  {statCodes.map((l, index) => {
                    return (
                      <MenuItem key={index} value={l.code}>
                        {l.name}
                      </MenuItem>
                    )
                  })}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField fullWidth label='과목명' size='small'
                defaultValue={terms?.title}
                onChange={(e) => {
                  terms.title = e.target.value
                  termsRef.current = terms
                }}
              />
            </Grid> 
            <Grid item xs={12} md={3}>
              <Button fullWidth size='middle' style={{marginBottom:5}}
                onClick={() => {
                  dgTimeRef.current.open()
                }}
              >
                출강가능 요건
              </Button>
              {
                demand.schs.length > 0 ? (
                  <Paper style={{border:'1px solid #eee', padding:5}} elevation={0}>
                    <div style={{display:'flex', flexDirection:'row'}}>
                      <Typography style={{fontWeight:'bold'}} variant='body2'>{demand.school.name}</Typography> &nbsp;
                      <Typography style={{fontWeight:'bold'}} variant='body2'>{demand.smst.year}/{demand.smst.gisu}</Typography>
                    </div>
                  {
                    demand.schs.map((row, idx) => (
                      <Grid key={idx} container spacing={2} >
                        <Grid item xs>
                          <Typography>{weekCodes.find(r => r.code === row.weekCode)?.name}</Typography>
                        </Grid>
                        <Grid item xs>
                          <Typography>{row.startTime} ~ {row.endTime}</Typography>
                        </Grid>
                      </Grid>
                    ))
                  }
                  </Paper>

                ) : null
              }
            </Grid> 
            <Grid item xs={12} >
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <Button fullWidth size='middle' variant='contained'
                    onClick={() => {
                      set_terms({})
                      set_demand({schs:[]})
                      set_termsKey(Date.now())
                    }}
                  >
                    조건 초기화
                  </Button>

                </Grid>
                <Grid item xs={6}>
                  <Button fullWidth size='middle' variant='contained'
                    ref={buttonRef}
                    onClick={() => {
                      onLoad()
                    }}
                  >
                    검색
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <MUITable style={{marginTop:20}}>
            <MyTableHead >
              <TableRow>
                <TableCell>No.</TableCell>
                {
                  fields.map((col, index) => {
                    if(col.visible) {
                      return(
                        <TableCell key={index} size='small' >
                          {
                            col.sortable ? (
                              <TableSortLabel
                                active={sortBy === col.field}
                                direction={sortBy === col.field? sortDirection: 'asc'}
                                onClick={() => handleSort(col.field)}
                              >
                                {col.placeholder}
                              </TableSortLabel>
                            ) : <>{col.placeholder}</>
                          }
                          {col.canSrch? 
                            ( 
                              <Fragment>
                                  <TextField label="" variant="outlined" size='small' inputProps={{style: {fontSize: '0.875em', padding:5, backgroundColor:'#fff'}}} 
                                    value={terms[col.field]}
                                    onChange={(e) => {
                                      const newTerms = {...terms}
                                      newTerms[col.field] = e.target.value
                                      set_terms(newTerms)
                                    }}
                                  />
                              </Fragment>
                            )
                            : (
                              <Fragment>
                              </Fragment>
                            )
                          }
                        </TableCell>
                      )
                    }
                  })
                }
                <TableCell size='small'>
                  
                  관리
                  {/* 
                  <FlatButton size='small' variant='outlined' style={{marginRight:5}} color='primary' onClick={onSearch}>검색</FlatButton>
                  <FlatButton size='small' variant='outlined'  color='primary' onClick={onClear}>지우기</FlatButton>
                  */}
                  
                </TableCell>
              </TableRow>
            </MyTableHead>
            <TableBody>
              {
                dataList.map((row, index) => {
                  return(
                    <Fragment key={index}>
                      <TableRow onClick={()=> {
                        set_selIdx(index)
                        set_record(row)
                      }}>
                        <TableCell>{index + 1}</TableCell>
                          {
                            fields.map((col, index2) => {
                              if(col.visible) {
                                if(col.field === 'title') {
                                  return(
                                    <TableCell key={index2} size='small' >
                                      {
                                        row.lectures?.map(l => (
                                          <Typography style={{fontWeight:'bold', cursor:'pointer'}} variant='body2'
                                            onMouseOver={(e) => {
                                              lectureRef.current = l
                                              schoolRef.current = row.school
                                            }}
                                            onClick={(e) => {
                                              dgRef.current.open()
                                            }}
                                          >
                                           {l.title}
                                          </Typography>
                                        ))
                                      }
                                    </TableCell>
                                  )
                                }
                                else {
                                  return(
                                    <TableCell key={index2} size='small'>
                                      {row[col.field]}
                                    </TableCell>
                                  )
                                }
                              }
                            })
                          }
                          <TableCell size='small'>
                            <ConfirmDialog
                              btn={<FlatButton style={{marginRight:5}} disabled={row.statCode !== 'S001'}>승인</FlatButton>}
                              title={'알림'}
                              content={'승인 처리 하시겠습니까?'}
                              bc={'primary'}
                              preHandle={ async () => {
                                return true
                              }}
                              perform={() => {
                                onResolve(row.id, 'S002')
                              }}
                            />
                            <ConfirmDialog
                              btn={<FlatButton color='warning' style={{marginRight:5}} disabled={row.statCode !== 'S001'}>거부</FlatButton>}
                              title={'알림'}
                              content={'데이터는 삭제됩니다. 거부 처리 하시겠습니까?'}
                              bc={'warning'}
                              preHandle={ async () => {
                                return true
                              }}
                              perform={() => {
                                onResolve(row.id, 'DEL')
                              }}
                            />
                            <ConfirmDialog
                              btn={<FlatButton color='warning' style={{marginRight:5}} >삭제</FlatButton>}
                              title={'알림'}
                              content={'해당 강사 삭제 후 수정이 필요한 강좌에서 강사정보를 별도로 수정해 주세요.  삭제하시겠습니까? '}
                              bc={'warning'}
                              preHandle={ async () => {
                                return true
                              }}
                              perform={() => {
                                delSchoolUserRltn(row.id)
                              }}
                            />


                            {/*<FlatButton variant='contained' size='small'  style={{marginRight:5}} onClick={() => onResolve(row.id, 'S002')} disabled={row.statCode !== 'S001'}>승인</FlatButton>*/}
                            {/*<FlatButton variant='contained' size='small'  style={{marginRight:5}} onClick={() => onResolve(row.id, 'DEL')} disabled={row.statCode !== 'S001'}>거부</FlatButton>*/}
                          </TableCell>
                        </TableRow>
                      </Fragment>
                  )
                })
              }
            </TableBody>
            <TableFooter>
            <TableRow>
             <TablePagination
                sx={{
                  [`& .${tablePaginationClasses.spacer}`]: {
                    display: "none"
                  },
                  [`& .${tablePaginationClasses.toolbar}`]: {
                    justifyContent: "center"
                  }
                }}
                rowsPerPageOptions={[10, 20, 100, { label: 'All', value: -1 }]}
                // colSpan={visibleColumns.length + 2}
                count={totalCount}
                rowsPerPage={pageInfo.pageSize}
                page={pageInfo.pageNum}
                SelectProps={{
                  inputProps: {
                    'aria-label': 'rows per page',
                  },
                  native: true,
                }}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                ActionsComponent={TablePaginationActions}
                labelDisplayedRows={
                  ({ from, to, count }) => {
                    // return '' + from + '-' + to + ' 개 ' + count
                    return `${from} - ${to} of ${count}`
                  }
                }
                labelRowsPerPage={'페이지당 갯수'}
              />
           
             
            </TableRow>
          </TableFooter>
          </MUITable>
           {renderSnackbar()}
           {renderIndicator()}
           {renderAlert()}
          </div>

      </div>
      
    );
  }
  
}

export default ProfileCompanyTeacherPage
